import { Image } from "antd";
import AttachmentIcon from "../../../../../assets/icons/AttachmentIcon";

type Props = { attachments: string[] };

const EmailAttachments = ({ attachments }: Props) => {
  if (attachments?.length < 1) {
    return <></>;
  }

  const imageExtensions = ["jpg", "jpeg", "png", "gif", "webp", "bmp", "svg"];

  // Separate images and other files
  const imageFiles = attachments.filter((fileUrl) => {
    const ext = fileUrl.split(".").pop()?.toLowerCase();
    return ext && imageExtensions.includes(ext);
  });

  const otherFiles = attachments.filter((fileUrl) => {
    const ext = fileUrl.split(".").pop()?.toLowerCase();
    return !ext || !imageExtensions.includes(ext);
  });

  return (
    <div className="ml-[75px]">
      <div className="text-sm font-semibold text-header mb-2">
        {attachments?.length ?? 0} Attachment
        {(attachments?.length ?? 0) > 1 ? "s" : ""}
      </div>
      {/* Image Preview Group */}
      {imageFiles.length > 0 && (
        <Image.PreviewGroup>
          <div className="flex flex-wrap gap-2 mb-4">
            {imageFiles.map((fileUrl, index) => (
              <Image
                key={index}
                width={128}
                height={128}
                src={fileUrl}
                alt={`attachment-${index}`}
                style={{
                  objectFit: "cover",
                  borderRadius: "8px",
                  border: "1px solid #cccccc",
                  overflow: "hidden",
                }}
              />
            ))}
          </div>
        </Image.PreviewGroup>
      )}

      {/* Other files */}
      {otherFiles.length > 0 && (
        <div className="flex flex-col">
          {otherFiles.map((fileUrl, index) => {
            const extension = fileUrl.split(".").pop()?.toLowerCase();
            return (
              <a
                key={index}
                href={fileUrl}
                target="_blank"
                rel="noopener noreferrer"
                className="flex items-center gap-2 text-blue-600 font-medium mb-2"
              >
                <AttachmentIcon /> Download Attachment ( .{extension || "file"})
              </a>
            );
          })}
        </div>
      )}
    </div>
  );
};

export default EmailAttachments;
